<template>
    <div id="course">
        <div class="course1">
            <img :src="url+banner.images" alt="" @click="jumpbannerpage(banner.url)">
        </div>
        <div class="course2">
            <p class="title" v-html="course2.title"></p>
            <ul>
                <li class="wow animate__animated animate__fadeInLeft"><img :src="url+course2.images[0]" alt=""></li>
                <li class="wow animate__animated animate__fadeInRight"><img :src="url+course2.images[1]" alt=""></li>
            </ul>
        </div>
        <div class="course3">
            <div class="course3_1">
                <ul>
                    <li v-for="(item,index) in course3.course3_1" :key="index"  class="wow animate__animated animate__fadeInUp">
                        <img :src="url+item.images" alt="">
                        <p class="p1">{{item.title}}</p>
                        <p class="p2" v-html="item.subtitle"></p>
                    </li>
                </ul>
            </div>
            <div class="course3_2">
                <p class="title" v-html="course3.course3_2_title.title"></p>
                <ul>
                    <li v-for="(item,index) in course3.course3_2" :key="index" @mouseover="changeCourse3index=index" class="wow animate__animated animate__fadeInDown">
                        <div class="notOn" v-show="changeCourse3index!=index">
                            <img :src="url+item.images[0]" alt="">
                            <p class="p1">{{item.title}}</p>
                            <p class="p2">{{item.subtitle}}</p>
                        </div>
                        <div class="on"  v-show="changeCourse3index==index">
                            <img :src="url+item.images[1]" alt="">
                            <p class="p1">{{item.title}}</p>
                            <p class="p2">{{item.subtitle}}</p>
                            <p class="icon"><img src="@/assets/course/go.png" alt=""></p>
                        </div>
                    </li>
                </ul>
                <div class="couresButton">
                    <button @click="submit(false)">报名课程</button>
                    <button @click="submit(true)">立即报名</button>
                </div>
            </div>
        </div>
        <div class="course4">
            <p class="title" v-html="course3.course3_3.title"></p>
            <p class="subtitle" v-html="course3.course3_3.subtitle"></p>
            <ul>
                <li class="wow animate__animated animate__fadeInLeft">
                    <img :src="url+course3.course3_3.images[0]" alt="">
                </li>
                <li class="wow animate__animated animate__fadeInRight">
                    <img :src="url+course3.course3_3.images[1]" alt="">
                </li>
            </ul>
        </div>
        <div class="course5">
            <img :src="url+course3.course3_4.images" alt="">
            <div>
                <p class="title">{{course3.course3_4.title}}</p>
                <ul>
                    <li v-for="(item,index) in course3.course3_5" :key="index">{{item.title}}</li>
                </ul>
            </div>
        </div>
        <div class="course6">
            <button @click="submit(false)">报名课程</button>
            <button @click="submit(true)">立即报名</button>
        </div>
        <mydialog v-if="showtc2" @tcstatus="tcstatus" :dialogVisible1="tcshow" :imgurl="url+weichat.images"></mydialog>
    </div>
</template>

<script>
import mydialog from '@/components/dialog/dialog.vue'
import { rotationmap,course } from '@/api/api'
export default {
    name:"course",
    components: {
        mydialog
    },
    data(){
        return {
            showtc2:false,
            tcshow:true,
            url : window.url, 
            weichat:{},
            banner: {}, 
            changeCourse3index:0,
            course2:{},
            course3:{
                course3_1:[

                ],
                course3_2_title:{},
                course3_2:[

                ],
                course3_3:{},
                course3_4:{},
                course3_5:[],
            }
        }
    },
    mounted(){
        var that = this
        rotationmap({'type':1}).then((response) => {
            that.banner = response.data.data[0]
        })
        rotationmap({'type':13}).then((response) => {
            that.weichat = response.data.data[0]
        })
        course().then((response) => {
            response.data.data[0][0].images = response.data.data[0][0].images.split(',')
            response.data.data[4][0].images = response.data.data[4][0].images.split(',')
            that.course2 = response.data.data[0][0]
            that.course3.course3_1 = response.data.data[1]
            that.course3.course3_2_title = response.data.data[2][0]
            for(let i = 0;i<response.data.data[3].length;i++){
                response.data.data[3][i].images = response.data.data[3][i].images.split(',')
            }
            that.course3.course3_2 = response.data.data[3]
            that.course3.course3_3 = response.data.data[4][0]
            that.course3.course3_4 = response.data.data[5][0]
            that.course3.course3_5 = response.data.data[6]
            //初始化动画
            that.$nextTick(()=>{
                that.$wow.init()
            })
        })
    },
    methods:{
        tcstatus(e){
            this.showtc2 = e
        },
        submit(e){
            this.showtc2 = true
            this.tcshow = e
        },
        jumpbannerpage(e){
            this.showtc2 = true
            if(e != this.$route.path) {
                this.$router.push(e)
            }
        }
    }
}
</script>

<style lang="less">
    :root {
        --web-title-fontsize: 30px;
        --web-subtitle-fontsize: 22px;
        --web-text-fontsize: 16px;
    } 
    @media (min-width:750px) {
        #course{
            .course1{
                img{
                    width: 100%;
                    display: block;
                }
            }
            .course2{
                width: 100%;
                margin:42px auto 0;
                padding-bottom: 50px;
                .title{
                    font-size: var(--web-title-fontsize);
                    color: #111111;
                    text-align: center;
                    margin-bottom: 100px;
                    span{
                        color:#355EFC;
                    }
                }
                ul{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    li:nth-child(1) img{
                        width: 498px;
                    }
                    li:nth-child(2) img{
                        width: 793px;
                    }
                }
            }
            .course3{
                background-color: #FAFAFA;
                padding: 100px 0;
                .course3_1{
                    width: 1300px;
                    margin:0 auto;
                    ul{
                        display: flex;
                        justify-content: space-between;
                        li{
                            width: 271px;
                            height: 266px;
                            background: #FFFFFF;
                            box-shadow: inset 0px 3px 12px 1px rgba(0,0,0,0.16);
                            border-radius: 8px 8px 8px 8px;
                            position: relative;
                            padding-top: 120px;
                            text-align: center;
                            img{
                                position: absolute;
                                top: -44px;
                                left: 50%;
                                transform: translateX(-50%);
                            }
                            .p1{
                                font-size: var(--web-subtitle-fontsize);
                                font-weight: 500;
                                color: #343434;
                                margin-bottom: 15px;
                            }
                            .p2{
                                font-size: var(--web-text-fontsize);
                                font-weight: 400;
                                color: #777777;
                            }
                        }
                    }
                }
                .course3_2{
                    width: 1300px;
                    margin:83px auto 0;
                    .title{
                        font-size: var(--web-title-fontsize);
                        font-weight: 400;
                        color: #111111;
                        text-align: center;
                        margin-bottom: 80px;
                    }
                    ul{
                        display: flex;
                        background: #FFFFFF;
                        box-shadow: 0px 3px 12px 1px rgba(66,105,153,0.16);
                        border-radius: 10px 10px 10px 10px;
                        padding: 0 90px;
                        text-align: center;
                        justify-content: space-between;
                        align-items: center;
                        height: 186px;
                        img{
                            width: 64px;
                        }
                        .notOn{
                            width: 201px;
                            font-size: var(--web-text-fontsize);
                            color: #333333;
                        }
                        .on{
                            width: 201px;
                            height: 242px;
                            background: #355EFC;
                            box-shadow: 0px 7px 49px 1px rgba(59,174,222,0.48);
                            border-radius: 10px 10px 10px 10px;
                            font-size: var(--web-text-fontsize);
                            color: #fff;
                            position: relative;
                            padding: 50px;
                            .icon{
                                position: absolute;
                                bottom: 15px;
                                right: 0;
                                width: 50px;
                                height: 42px;
                                border-radius: 10px 0px 0px 10px;
                                background-color: #fff;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                img{
                                    width: 12px;
                                }
                            }
                        }
                    }
                }
                .couresButton{
                    display: flex;
                    justify-content: center;
                    margin-top: 128px;
                    button:nth-child(1){
                        width: 238px;
                        height: 76px;
                        background: #355EFC;
                        border-radius: 61px 61px 61px 61px;
                        font-size: var(--web-subtitle-fontsize);
                        font-weight: 500;
                        color: #FFFFFF;
                        margin-right: 155px;
                        cursor: pointer;
                    }
                    button:nth-child(2){
                        width: 238px;
                        height: 76px;
                        border: 1px solid #355EFC;
                        background-color: transparent;
                        border-radius: 61px 61px 61px 61px;
                        font-size: var(--web-subtitle-fontsize);
                        font-weight: 500;
                        color: #355EFC;
                        cursor: pointer;
                    }
                }
            }
            .course4{
                width: 1300px;
                margin:58px auto 0;
                .title{
                    font-size: var(--web-title-fontsize);
                    color: #111;
                    text-align: center;
                    margin-bottom: 28px;
                    span{
                        color: #355EFC;
                    }
                }
                .subtitle{
                    font-size: var(--web-subtitle-fontsize);
                    font-weight: 400;
                    color: #696969;
                    text-align: center;
                }
                ul{
                    margin-top: 90px;
                    display: flex;
                    justify-content: center;
                    li:nth-child(1) img{
                        width: 600px;
                    }
                    li:nth-child(2){
                        margin-left:-127px ;
                        margin-top:-50px ;
                    }
                    li:nth-child(2) img{
                        width: 600px;
                    }
                }
            }

            .course5{
                position: relative;
                margin-top: 46px;
                img{
                    width: 100%;
                }
                div{
                    padding: 65px 0;
                    width: 80%;
                    background: rgba(255, 255, 255,0.2);
                    backdrop-filter: blur(8px);//背景模糊
                    border-radius: 10px 10px 10px 10px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    color: #fff;
                    .title{
                        font-size: var(--web-title-fontsize);
                        font-weight: 400;
                        text-align: center;
                        margin-bottom: 57px;
                    }
                    ul{
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        width: 70%;
                        margin:0 auto;
                        li{
                            flex: 0 0 50%;
                            font-size: var(--web-text-fontsize);
                            font-weight: 500;
                        }
                        li:nth-child(-n+2){
                            margin-bottom: 43px;
                        }
                    }
                }
            }
            .course6{
                display: flex;
                justify-content: center;
                padding: 60px 0;
                button:nth-child(1){
                    width: 238px;
                    height: 76px;
                    background: #355EFC;
                    border-radius: 61px 61px 61px 61px;
                    font-size: var(--web-subtitle-fontsize);
                    font-weight: 500;
                    color: #FFFFFF;
                    margin-right: 155px;
                    cursor: pointer;
                }
                button:nth-child(2){
                    width: 238px;
                    height: 76px;
                    border: 1px solid #355EFC;
                    background-color: transparent;
                    border-radius: 61px 61px 61px 61px;
                    font-size: var(--web-subtitle-fontsize);
                    font-weight: 500;
                    color: #355EFC;
                    cursor: pointer;
                }
            }
        }
    }
    @media screen and (max-width:750px) {
        #course{
            .course1{
                img{
                    width: 100%;
                    display: block;
                }
            }
            .course2{
                width: 100%;
                margin:42px auto 0;
                padding-bottom: 50px;
                .title{
                    font-size: 1.25rem;
                    color: #111111;
                    text-align: center;
                    margin-bottom: 20px;
                    span{
                        color:#355EFC;
                        font-size: 1.50rem;
                    }
                }
                ul{
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    text-align: center;
                    li:nth-child(1) img{
                        width: 90%;
                    }
                    li:nth-child(2) img{
                        margin-top: 20px;
                        width: 90%;
                    }
                }
            }
            .course3{
                background-color: #FAFAFA;
                padding: 20px 0;
                .course3_1{
                    width: 100%;
                    margin:0 auto;
                    ul{
                        display: flex;
                        justify-content: space-between;
                        flex-wrap: wrap;
                        margin:0 10px;
                        li{
                            flex:0 0 49%;
                            background: #FFFFFF;
                            box-shadow: inset 0px 3px 12px 1px rgba(0,0,0,0.16);
                            border-radius: 8px 8px 8px 8px;
                            position: relative;
                            padding-top: 70px;
                            text-align: center;
                            height: 180px;
                            img{
                                position: absolute;
                                top: -44px;
                                left: 50%;
                                transform: translateX(-50%);
                                width: 100%;
                            }
                            .p1{
                                font-size: 20px;
                                font-weight: 500;
                                color: #343434;
                                margin-bottom: 15px;
                            }
                            .p2{
                                font-size: 16px;
                                font-weight: 400;
                                color: #777777;
                            }
                        }
                        li:nth-child(-n+2){
                            margin-bottom: 80px;
                        }
                    }
                }
                .course3_2{
                    width: 100%;
                    margin:40px auto 0;
                    .title{
                        font-size: 1.25rem;
                        font-weight: 400;
                        color: #111111;
                        text-align: center;
                        margin-bottom: 40px;
                    }
                    ul{
                        display: flex;
                        background: #FFFFFF;
                        box-shadow: 0px 3px 12px 1px rgba(66,105,153,0.16);
                        border-radius: 10px 10px 10px 10px;
                        padding: 0 10px;
                        text-align: center;
                        justify-content: space-between;
                        align-items: center;
                        height: 86px;
                        img{
                            width: 34px;
                        }
                        .notOn{
                            width: 100px;
                            font-size: 14px;
                            color: #333333;
                        }
                        .on{
                            width: 100px;
                            height: 120px;
                            background: #355EFC;
                            box-shadow: 0px 7px 49px 1px rgba(59,174,222,0.48);
                            border-radius: 10px 10px 10px 10px;
                            font-size: 14px;
                            color: #fff;
                            position: relative;
                            padding: 10px;
                            .icon{
                                position: absolute;
                                bottom: 15px;
                                right: 0;
                                width: 20px;
                                height: 20px;
                                border-radius: 10px 0px 0px 10px;
                                background-color: #fff;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                img{
                                    width: 10px;
                                }
                            }
                        }
                    }
                }
                .couresButton{
                    display: flex;
                    justify-content: space-between;
                    margin-top: 48px;
                    padding: 0 20px;
                    button:nth-child(1){
                        width: 138px;
                        height: 46px;
                        background: #355EFC;
                        border-radius: 61px 61px 61px 61px;
                        font-size: 18px;
                        font-weight: 500;
                        color: #FFFFFF;
                        cursor: pointer;
                    }
                    button:nth-child(2){
                        width: 138px;
                        height: 46px;
                        border: 1px solid #355EFC;
                        background-color: transparent;
                        border-radius: 61px 61px 61px 61px;
                        font-size: 18px;
                        font-weight: 500;
                        color: #355EFC;
                        cursor: pointer;
                    }
                }
            }
            .course4{
                width: 100%;
                margin:58px auto 0;
                .title{
                    font-size: 1.25rem;
                    color: #111;
                    text-align: center;
                    margin-bottom: 28px;
                    span{
                        font-size: 1.5rem;
                        color: #355EFC;
                    }
                }
                .subtitle{
                    font-size: 1.25rem;
                    font-weight: 400;
                    color: #696969;
                    text-align: center;
                }
                ul{
                    margin-top: 90px;
                    width: 90%;
                    margin:90px auto 0;
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;
                    li:nth-child(1) img{
                        width: 100%;
                    }
                    li:nth-child(2) img{
                        width: 100%;
                    }
                }
            }

            .course5{
                position: relative;
                margin-top: 46px;
                img{
                    width: 100%;
                }
                div{
                    padding: 20px 0;
                    width: 80%;
                    background: rgba(255, 255, 255,0.2);
                    backdrop-filter: blur(8px);//背景模糊
                    border-radius: 10px 10px 10px 10px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    color: #fff;
                    .title{
                        font-size: 1.25rem;
                        font-weight: 400;
                        text-align: center;
                        margin-bottom: 20px;
                    }
                    ul{
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        width: 90%;
                        margin:0 auto;
                        li{
                            flex: 0 0 50%;
                            font-size: 14px;
                            font-weight: 500;
                        }
                        li:nth-child(-n+2){
                            margin-bottom: 10px;
                        }
                    }
                }
            }
            .course6{
                display: flex;
                justify-content: space-between;
                margin-top: 48px;
                margin-bottom: 30px;
                padding: 0 20px;
                button:nth-child(1){
                    width: 138px;
                    height: 46px;
                    background: #355EFC;
                    border-radius: 61px 61px 61px 61px;
                    font-size: 18px;
                    font-weight: 500;
                    color: #FFFFFF;
                    cursor: pointer;
                }
                button:nth-child(2){
                    width: 138px;
                    height: 46px;
                    border: 1px solid #355EFC;
                    background-color: transparent;
                    border-radius: 61px 61px 61px 61px;
                    font-size: 18px;
                    font-weight: 500;
                    color: #355EFC;
                    cursor: pointer;
                }
            }
        }
    }
</style>